import React from 'react';
import { CSSTransition } from 'react-transition-group';

function ModalTransition(props) {
  return <CSSTransition {...props} timeout={{ enter: 300, leave: 300 }} />;
}

export default ModalTransition;
